import properties from '../../../constants/Properties';
import { changeElementPosition, addAudioToTimeline, selectElement, setMarkerPosition, moveBlock, dragAndCloneElement } from '../../../actions/AudioEditorActions';
import audioEditorUtils from './AudioEditorUtils';
import mouseUtils from '../../utils/MouseUtils';
import playController from '../../utils/PlayController';
import appParameters from '../../utils/AppParameters';
import storeManager from '../../../store/StoreManager';
import uuid from 'uuid';
import durationUtils from '../../utils/DurationUtils';
import saveManager from '../../utils/SaveManager';
import audioToolUtils from '../../audioTool/utils/AudioToolUtils';
import platformDetection from '../../utils/PlatformDetection';

const timelineDragManager = {
    dragElement: undefined,
    limits: undefined,
    startX: undefined,
    startY: undefined,
    itemWidth: undefined,
    dropIndex: -1,
    dropPosition: -1,
    isShift: false,
    isKeyboardEventsInit: false,

    getLimits(windowHeight, leftPos, topPos) {
        this.limits = [];

        var timelinesLength = audioEditorUtils.getTimelinesLength();
        var audioEditorHeight = timelinesLength * audioToolUtils.timelineHeight() + 30;
        var topGlobalLimit;
        var i;

        if (audioToolUtils.isAudioTool()) {
            topGlobalLimit = audioToolUtils.headerHeight() + audioToolUtils.getTimelineComponentTopOffset();

            if (platformDetection.isIOSApp())
                topGlobalLimit = topGlobalLimit + properties.CLIPART_BUTTON_HEIGHT;
        } else
            topGlobalLimit = windowHeight - audioEditorHeight;

        for (i=0; i<= timelinesLength; i++)
            this.limits.push(audioToolUtils.timelineHeight() * i);

        this.startX = leftPos;
        this.startY = topPos - topGlobalLimit;
    },
    getCssProperty(value) {
        return Number(value.substring(0, value.length - 2));
    },
    addKeyboardEvents() {
        if (!this.isKeyboardEventsInit) {
            document.addEventListener('keydown', this.onKeyDown.bind(this));
            document.addEventListener('keyup', this.onKeyUp.bind(this));
            this.isKeyboardEventsInit = true;
        }
    },
    onKeyDown(e) {
        if (e.shiftKey)
            this.isShift = true;
    },
    onKeyUp(e) {
        if (e.shiftKey)
            this.isShift = true;
        else
            this.isShift = false;
    },
    createClone(target, windowHeight, leftPos, topPos, itemWidth) {
        this.addKeyboardEvents();

        var parent = document.getElementById('timeline');

        if (this.dragElement && this.dragElement.parentNode)
            this.dragElement.parentNode.removeChild(this.dragElement);

        this.getLimits(windowHeight, leftPos, topPos);

        var holder = document.createElement('div');
        holder.style.position = 'absolute';
        holder.style.left = this.startX + 'px';
        holder.style.top = this.startY + 'px';
        // holder.style.cursor = '-webkit-grabbing';
        holder.style.opacity = 0;

        var clone = target.cloneNode(true);
        clone.style.position = 'absolute';
        clone.style.left = '0px';
        clone.style.paddingTop = '0px';
        clone.style.paddingLeft = '0px';
        // clone.style.cursor = '-webkit-grabbing';
        clone.style.display = 'block';
        clone.style.height = (this.getCssProperty(clone.style.height) - 2) + 'px';

        holder.appendChild(clone);
        this.dragElement = holder;

        parent.appendChild(this.dragElement);

        this.itemWidth = itemWidth;

        this.clearScrollInverval();
    },
    move(offsetX, offsetY, e) {
        var target = this.dragElement;

        if (target == undefined)
            return;

        target.style.opacity = 0.8;

        var newX = this.startX + offsetX;
        var newY = this.startY + offsetY;
        var i;

        if (newY < this.limits[0]) {
            newY = this.limits[0];
            this.dropIndex = 0;
        } else if (newY >= this.limits[this.limits.length - 1]) {
            newY = this.limits[this.limits.length - 2];
            this.dropIndex = this.limits.length - 2;
        } else {
            for (i = 0; i < this.limits.length - 1; i++) {
                if (newY >= this.limits[i] && newY < this.limits[i + 1]) {
                    newY = this.limits[i];
                    this.dropIndex = i;
                    break;
                }
            }
        }

        if (newX <= 0)
            newX = 0;

        target.style.top = (newY + 2) + 'px';
        target.style.left = newX + 'px';

        this.dropPosition = newX;

        this.checkScroll(offsetX, e);
    },

    moveScroll: undefined,
    positionValue: 1,
    scrollTimerVar: undefined,
    checkScroll(offsetX, e) {
        var position = mouseUtils.getTouchPosition(e);

        if (position.x > this.getLeftLimit() && position.x < this.getRightLimit()) {
            this.clearScrollInverval();
            return;
        }

        if (position.x >= this.getRightLimit()) {
            if (!this.scrollTimerVar) {
                this.positionValue = 1;
                this.scrollTimerVar = setInterval(this.moveScrollAtInterval.bind(this), 100);
                this.moveScroll();
            }

        } else if (position.x <= this.getLeftLimit()) {
            if (!this.scrollTimerVar) {
                this.positionValue = -1;
                this.scrollTimerVar = setInterval(this.moveScrollAtInterval.bind(this), 100);
                this.moveScroll(-1);
            }
        }
    },
    moveScrollAtInterval() {
        this.moveScroll(this.positionValue);

        var leftPos = this.dragElement.style.left.replace('px', '');
        leftPos = parseInt(leftPos);

        if (this.positionValue > 0)
            this.dropPosition = leftPos + properties.AUTO_SCROLL_STEP;
        else
            this.dropPosition = leftPos - properties.AUTO_SCROLL_STEP;

        if (this.dropPosition < 0)
            this.dropPosition = 0;

        this.dragElement.style.left = this.dropPosition + 'px';
    },
    clearScrollInverval() {
        if (this.scrollTimerVar)
            clearInterval(this.scrollTimerVar);

        this.scrollTimerVar = undefined;
    },
    getLeftLimit() {
        return audioToolUtils.buttonsHolderWidth();
    },
    getRightLimit() {
        const state = storeManager.getState();
        var windowWidth = state.production.windowWidth;
        var accordionWidth = state.accordion.width;

        if (!(windowWidth > 0))
            windowWidth = window.innerWidth;

        if (accordionWidth == undefined)
            accordionWidth = properties.BROWSER_WIDTH;

        return (windowWidth - accordionWidth);
    },

    removeClone(dispatch, properties) {
        if (this.dragElement && this.dragElement.parentNode)
            this.dragElement.parentNode.removeChild(this.dragElement);

        if (this.isShift)
            this.dragAndClone(dispatch, properties);
        else
            this.setNewPosition(dispatch, properties);

        this.clearScrollInverval();
    },
    dragAndClone(dispatch, properties) {
        if (this.dropIndex != -1 && this.dropPosition != -1) {
            properties.endIndex = this.dropIndex;
            properties.audio.left = audioEditorUtils.getItemTimePosition(this.dropPosition);

            dispatch(setMarkerPosition(properties.audio.left));
            dispatch(dragAndCloneElement(properties));

            saveManager.isContentChanged(true);
            audioEditorUtils.addActionToHistory();
            audioEditorUtils.checkTimelineWidth();
        }

        this.dropIndex = -1;
        this.dropPosition = -1;
    },
    setNewPosition(dispatch, properties) {
        if (this.dropIndex != -1 && this.dropPosition != -1) {
            properties.endIndex = this.dropIndex;
            properties.audio.left = audioEditorUtils.getItemTimePosition(this.dropPosition);

            if (!properties.audio.showControlPoint)
                dispatch(selectElement(properties.audio.uuid, true));

            dispatch(changeElementPosition(properties));

            setTimeout(this.checkMarkerPosition.bind(this), 10);

            saveManager.isContentChanged(true);
            audioEditorUtils.addActionToHistory();
            audioEditorUtils.checkTimelineWidth();
        }

        this.dropIndex = -1;
        this.dropPosition = -1;
    },
    checkMarkerPosition() {
        const state = storeManager.getState();
        var dispatch = storeManager.getStore().dispatch;
        var markerPosition = state.audioEditor.markerPosition;
        var markerLastPosition = audioEditorUtils.getTimelinesMaxPosition();

        if (markerPosition > markerLastPosition)
            dispatch(setMarkerPosition(markerLastPosition));
    },

    //Drag-drop functionality for Audio menus
    audioItem: undefined,
    accordionWidth: -1,
    windowWidth: -1,
    windowHeight: -1,

    createAudioClone() {
        this.removeOldAudioItem();

        var lineSize = 3;
        var size = audioToolUtils.timelineHeight();
        var holder = document.createElement('div');
        holder.style.position = 'absolute';
        holder.style.left = this.startX + 'px';
        holder.style.top = this.startY + 'px';
        holder.style.width = size + 'px';
        holder.style.height = size + 'px';
        holder.style.background = 'red';
        holder.style.opacity = 0;

        var insideFrame = document.createElement('div');
        insideFrame.style.position = 'absolute';
        insideFrame.style.left = lineSize + 'px';
        insideFrame.style.top = lineSize + 'px';
        insideFrame.style.width = (size - 2 * lineSize) + 'px';
        insideFrame.style.height = (size - 2 * lineSize) + 'px';
        insideFrame.style.background = '#47AFE3';
        holder.appendChild(insideFrame);

        var iconSize = 40;
        var icon = document.createElement('img');
        icon.style.position = 'absolute';
        icon.style.top = (size / 2 - iconSize / 2) + 'px';
        icon.style.left = (size / 2 - iconSize / 2) + 'px';
        icon.style.width = iconSize + 'px';
        icon.style.height = iconSize + 'px';
        icon.style.cursor = '-webkit-grabbing';
        icon.setAttribute('src', appParameters.RESOURCES_LOCATION() + 'assets/mySounds.png');

        holder.appendChild(icon);

        document.body.appendChild(holder);

        this.dragElement = holder;
    },
    removeOldAudioItem() {
        if (this.dragElement && this.dragElement.parentNode)
            this.dragElement.parentNode.removeChild(this.dragElement);
    },
    clearAudioItem() {
        this.audioItem = undefined;
    },
    startAudioDrag(e, item) {
        if (!playController.isAudioEditorMode())
            return;

        this.audioItem = item;
        var touchPosition = mouseUtils.getTouchPosition(e);

        this.startX = touchPosition.x;
        this.startY = touchPosition.y;

        this.getTimelinesLimits();
        this.createAudioClone();
    },
    moveAudio(e, coreEvent) {
        if (!playController.isAudioEditorMode() || !this.audioItem)
            return;

        var target = this.dragElement;

        if (target == undefined)
            return;

        target.style.opacity = 0.7;

        target.style.left = (this.startX + coreEvent.lastX) + 'px';
        target.style.top = (this.startY + coreEvent.lastY) + 'px';

        this.checkPosition(this.startX + coreEvent.lastX, this.startY + coreEvent.lastY);
    },
    endAudioDrag(e, coreEvent) {
        if (!playController.isAudioEditorMode() || !this.audioItem)
            return;

        this.checkPosition(this.startX + coreEvent.lastX, this.startY + coreEvent.lastY, true);

        this.removeOldAudioItem();
    },
    getTimelinesLimits() {
        this.limits = [];

        var state = storeManager.getState();
        var accordionWidth = state.accordion.width;

        if (accordionWidth == undefined)
            accordionWidth = properties.BROWSER_WIDTH;

        this.accordionWidth = accordionWidth;
        this.windowWidth = state.production.windowWidth;
        this.windowHeight = state.production.windowHeight;

        var timelinesLength = audioEditorUtils.getTimelinesLength();
        var audioEditorHeight = timelinesLength * audioToolUtils.timelineHeight() + 30;
        var i;
        var topGlobalLimit;

        if (audioToolUtils.isAudioTool()) {
            topGlobalLimit = audioToolUtils.headerHeight() + audioToolUtils.getTimelineComponentTopOffset();

            if (platformDetection.isIOSApp())
                topGlobalLimit = topGlobalLimit + properties.CLIPART_BUTTON_HEIGHT;
        } else
            topGlobalLimit = this.windowHeight - audioEditorHeight;

        for (i=0; i<=timelinesLength; i++)
            this.limits.push(topGlobalLimit + audioToolUtils.timelineHeight() * i);
    },
    checkPosition(x, y, isEndAction = false) {
        var topLimit = this.limits[0];
        var bottomLimit = this.limits[this.limits.length - 1];
        var leftLimit = audioToolUtils.buttonsHolderWidth();
        var rightLimit = this.windowWidth - this.accordionWidth;

        if (y > topLimit && y < bottomLimit && x > leftLimit && x < rightLimit) {
            this.dragElement.style.background = 'green';

            if (isEndAction)
                this.addItemToTimeline(x, y);
        } else {
            this.dragElement.style.background = 'red';
        }
    },
    addItemToTimeline(x, y) {
        var i;
        var currentIndex = -1;

        for (i=0; i<this.limits.length - 1; i++) {
            if (y >= this.limits[i] && y < this.limits[i+1]) {
                currentIndex = i;
                break;
            }
        }

        if (currentIndex < 0)
            return;

        var dispatch = storeManager.getStore().dispatch;
        var audio = {};

        audio.uuid = uuid.v4();
        audio.title = this.audioItem.title;
        audio.href = this.audioItem.href;
        audio.inPoint = 0;
        audio.outPoint = 0;
        audio.left = this.getLeftPosition(x); // added in seconds

        if (this.audioItem.durationInSeconds > 0)
            audio.duration = this.audioItem.durationInSeconds;
        else
            audio.duration = durationUtils.transformDurationFromStringToSeconds(this.audioItem.duration);

        playController.getOldScrollPosition();
        dispatch(addAudioToTimeline(currentIndex, audio));
        dispatch(setMarkerPosition(audio.left));
        saveManager.isContentChanged(true);

        audioEditorUtils.addActionToHistory();
        audioEditorUtils.checkTimelineWidth();
    },
    getLeftPosition(x) {
        var localX = x - audioToolUtils.buttonsHolderWidth();
        var scrollPos = playController.getScrollPosition();

        return audioEditorUtils.getItemTimePosition(scrollPos + localX);
    },

    /****** Multiple selection **************/
    multipleSelection: [],
    originalPositions: [],
    minLeftPos: -1,
    dispatch: undefined,
    blockClone: undefined,
    minIndex: -1,
    maxIndex: -1,

    resetMultipleSelection() {
        this.multipleSelection = [];
        this.removeBlockClone();
    },
    getMultipleSelection(start, end) {
        if (!(start.x != end.x || start.y != end.y)) {
            this.multipleSelection = [];
            return;
        }

        var timelinesLength = audioEditorUtils.getTimelinesLength();
        var trackHeight = audioToolUtils.timelineHeight();
        var topLimit = Math.min(start.y, end.y);
        var bottomLimit = Math.max(start.y, end.y);
        var indexArary = [];
        var i;

        for (i=0; i<timelinesLength; i++) {
            var trackTopPos = i * trackHeight;
            var trackBottomPos = (i+1) * trackHeight;

            if ((topLimit <= trackTopPos && bottomLimit > trackTopPos) || (bottomLimit >= trackBottomPos && topLimit < trackBottomPos) || (topLimit >= trackTopPos && bottomLimit <= trackBottomPos)){
                indexArary.push(i);
            }
        }

        if (indexArary.length == 0) {
            this.multipleSelection = [];
            return;
        }

        this.originalPositions = [];
        const state = storeManager.getState();
        const timelines = state.audioEditor.timelines;
        var timeline;
        var leftLimit = audioEditorUtils.getItemTimePosition(Math.min(start.x, end.x));
        var rightLimit = audioEditorUtils.getItemTimePosition(Math.max(start.x, end.x));
        var items = [];
        var minLeft = -1;
        var k;

        this.minIndex = -1;
        this.maxIndex = -1;

        for (k=0; k<indexArary.length; k++) {
            var currentIndex = indexArary[k];
            timeline = timelines[indexArary[k]];

            for (i = 0; i < timeline.audios.length; i++) {
                var audioLeftPos = timeline.audios[i].left;
                var audioRightPos = timeline.audios[i].left + timeline.audios[i].duration;

                if ((leftLimit <= audioLeftPos && rightLimit > audioLeftPos) || (rightLimit >= audioRightPos && leftLimit < audioRightPos) || (leftLimit >= audioLeftPos && rightLimit <= audioRightPos)) {
                    items.push(timeline.audios[i].uuid);

                    if (minLeft == -1)
                        minLeft = timeline.audios[i].left;
                    else
                        minLeft = Math.min(minLeft, timeline.audios[i].left);

                    this.originalPositions[timeline.audios[i].uuid] = {left: timeline.audios[i].left, index: currentIndex};

                    if (this.minIndex == -1) {
                        this.minIndex = currentIndex;
                        this.maxIndex = currentIndex;
                    } else {
                        this.minIndex = Math.min(this.minIndex, currentIndex);
                        this.maxIndex = Math.max(this.maxIndex, currentIndex);
                    }
                }
            }
        }

        this.multipleSelection = items;
        this.minLeftPos = minLeft;
    },
    isMultipleSelection(currentUid) {
        if (this.multipleSelection.length > 1 && this.multipleSelection.indexOf(currentUid) != -1)
            return true;
        else
            return false;
    },
    prepareClone() {
        if (this.multipleSelection.length < 1)
            return;

        var parent = document.getElementById('timeline');

        if (parent && this.blockClone && this.blockClone.parentNode)
            parent.removeChild(this.blockClone);

        var holder = document.createElement('div');
        holder.style.position = 'absolute';
        holder.style.left = this.startX + 'px';
        holder.style.top = this.startY + 'px';
        holder.style.opacity = 0;

        for (var i=0; i<this.multipleSelection.length; i++) {
            var target = document.getElementById('clone_' + this.multipleSelection[i]);

            if (!target)
                continue;

            var clone = target.cloneNode(true);

            clone.style.position = 'absolute';
            clone.style.left = audioEditorUtils.getSlideWidth(this.originalPositions[this.multipleSelection[i]].left - this.minLeftPos) + 'px';
            clone.style.top = this.getInternalTopPos(this.multipleSelection[i]) + 'px';
            clone.style.paddingTop = '0px';
            clone.style.paddingLeft = '0px';
            clone.style.display = 'block';
            // clone.style.background = '#ffffff';
            clone.style.height = (this.getCssProperty(clone.style.height) - 2) + 'px';

            holder.appendChild(clone);
        }

        this.blockClone = holder;

        parent.appendChild(this.blockClone);
    },
    getInternalTopPos(uuid) {
        var index = this.originalPositions[uuid].index - this.minIndex;
        return audioToolUtils.timelineHeight() * index;
    },
    startBlock(windowHeight, topPos, dispatch) {
        this.dispatch = dispatch;

        var leftPos = audioEditorUtils.getItemPosition(this.minLeftPos);
        this.getLimits(windowHeight, leftPos, topPos);
        this.prepareClone();
    },
    moveBlockWithOffset(offsetX, offsetY, uuid) {
        var target = this.blockClone;

        if (target == undefined)
            return;

        var properties = this.getCorrectPosition(offsetX, offsetY, uuid);

        target.style.opacity = 0.8;
        target.style.left = properties.x + 'px';
        target.style.top = (properties.y + 2) + 'px';
    },
    getCorrectPosition(offsetX, offsetY, uuid) {
        var newX = this.startX + offsetX;
        var newY = this.startY + offsetY;
        var i;
        var newIndex;
        var internalTopOffset = this.getInternalTopPos(uuid);
        var offsetIndex = this.maxIndex - this.minIndex;

        newY = newY - internalTopOffset;

        if (newY < this.limits[0]) {
            newY = this.limits[0];
            newIndex = 0;
        } else if (newY >= this.limits[this.limits.length - offsetIndex - 1]) {
            newY = this.limits[this.limits.length - offsetIndex - 2];
            newIndex = this.limits.length - offsetIndex - 2;
        } else {
            for (i = 0; i < this.limits.length - 1; i++) {
                if (newY >= this.limits[i] && newY < this.limits[i + 1]) {
                    newY = this.limits[i];
                    newIndex = i;
                    break;
                }
            }
        }

        if (newX <= 0)
            newX = 0;

        var props = {};
        props.x = newX;
        props.y = newY;
        props.indexOffset = newIndex - this.minIndex;

        return props;
    },
    removeBlockClone() {
        if (this.blockClone && this.blockClone.parentNode)
            this.blockClone.parentNode.removeChild(this.blockClone);
    },
    endBlock(offsetX, offsetY, uuid) {
        this.removeBlockClone();
        saveManager.isContentChanged(true);

        var properties = this.getCorrectPosition(offsetX, offsetY, uuid);
        var offset = audioEditorUtils.getItemTimePosition(properties.x - this.startX);

        setTimeout(function() {
            if (!this.dispatch)
                this.dispatch = storeManager.getStore().dispatch;

            this.dispatch(moveBlock(this.multipleSelection, offset, properties.indexOffset));
            audioEditorUtils.addActionToHistory();
        }.bind(this), 10);

        setTimeout(function() {
            this.updateBlockProperties(this.multipleSelection, offset, properties.indexOffset);
        }.bind(this), 20);
    },
    updateBlockProperties(multipleSelection, leftOffset, indexOffset) {
        this.minIndex = this.minIndex + indexOffset;
        this.maxIndex = this.maxIndex + indexOffset;
        this.minLeftPos = this.minLeftPos + leftOffset;

        this.originalPositions = [];
        const state = storeManager.getState();
        const timelines = state.audioEditor.timelines;

        for (var i=0; i<timelines.length; i++) {
            var audios = timelines[i].audios;

            for (var j=0; j<audios.length; j++) {
                if (multipleSelection.indexOf(audios[j].uuid) != -1) {
                    this.originalPositions[audios[j].uuid] = {left: audios[j].left, index: i};
                }
            }
        }
    }
};

export default timelineDragManager;



/** WEBPACK FOOTER **
 ** ./src/components/audioEditor/utils/TimelineDragManager.js
 **/